"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../utils/utils");
var load_more_1 = require("../features/load-more");
var request_analytes = __importStar(require("./request-analytes-for-laboratory-result"));
function init() {
    init_form();
    init_load_more();
}
exports.init = init;
function init_load_more() {
    var _a, _b;
    var saved_search_parameters = null;
    window.addEventListener('lgm.before-load-more', function (event) {
        var _a, _b, _c, _d, _e;
        if (!(event instanceof CustomEvent))
            return;
        var details = event.detail;
        // only on these resources
        if ([
            'analytes-and-profiles-guest',
            'analytes-and-profiles',
            'analytes',
        ].includes(details.resource) === false) {
            return;
        }
        // first load just accept
        if (saved_search_parameters === null) {
            saved_search_parameters = details.parameters;
            return;
        }
        // if title search has changed => delete first letter filter
        if (!!((_a = details.parameters) === null || _a === void 0 ? void 0 : _a.title_search) && saved_search_parameters.title_search !== ((_b = details.parameters) === null || _b === void 0 ? void 0 : _b.title_search)) {
            delete (details.parameters.first_letter);
        }
        // if first letter filter has changed => delete title_search
        if (!!((_c = details.parameters) === null || _c === void 0 ? void 0 : _c.first_letter) && saved_search_parameters.first_letter !== ((_d = details.parameters) === null || _d === void 0 ? void 0 : _d.first_letter)) {
            delete (details.parameters.title_search);
        }
        saved_search_parameters = (_e = details.parameters) !== null && _e !== void 0 ? _e : null;
    });
    var analytes_container = document.getElementById('analytes-container');
    if (analytes_container) {
        var params = {
            date_from: 0,
            date_to: 0,
            per_page: 10,
            sort_by: 'name',
            sort_order: 'asc',
            first_letter: 'A'
        };
        var is_request_for_laboratory_result_1 = analytes_container.hasAttribute('data-laboratory-result-id');
        if (is_request_for_laboratory_result_1) {
            params.laboratory_result_id = parseInt((_a = analytes_container.getAttribute('data-laboratory-result-id')) !== null && _a !== void 0 ? _a : '');
        }
        (0, load_more_1.initialize_load_more)('analytes', params).then(function (container) {
            if (is_request_for_laboratory_result_1) {
                // enable_input_fields_for_request_laboratory_result(container);
            }
        }).catch(function (e) { return console.error(e); });
    }
    var analytes_and_profiles_container = document.getElementById('analytes-and-profiles-container');
    if (analytes_and_profiles_container) {
        var params = {
            date_from: 0,
            date_to: 0,
            per_page: 999,
            sort_by: 'name',
            sort_order: 'asc',
            first_letter: 'A'
        };
        var is_request_for_laboratory_result_2 = analytes_and_profiles_container.hasAttribute('data-laboratory-result-id');
        if (is_request_for_laboratory_result_2) {
            params.laboratory_result_id = parseInt((_b = analytes_and_profiles_container.getAttribute('data-laboratory-result-id')) !== null && _b !== void 0 ? _b : '');
        }
        (0, load_more_1.initialize_load_more)('analytes-and-profiles', params).then(function (container) {
            if (is_request_for_laboratory_result_2) {
                // enable_input_fields_for_request_laboratory_result(container);
            }
        }).catch(function (e) { return console.error(e); });
    }
    var analytes_and_profiles_guest_container = document.getElementById('analytes-and-profiles-guest-container');
    if (analytes_and_profiles_guest_container) {
        var params = {
            date_from: 0,
            date_to: 0,
            per_page: 999,
            sort_by: 'name',
            sort_order: 'asc',
            first_letter: 'A'
        };
        (0, load_more_1.initialize_load_more)('analytes-and-profiles-guest', params).catch(function (e) { return console.error(e); });
    }
}
function init_form() {
    var form = (0, utils_1.get_element_by_id_or_null)('request-for-laboratory-result', HTMLFormElement);
    if (form) {
        request_analytes.init(form);
    }
}
